import { UserSubscriptionDetails } from '@anm/api/modules/user';

const getStudioSubscription = (subscriptions: UserSubscriptionDetails[]) =>
  subscriptions.find(({ product }) => product === 'STUDIO');

export default getStudioSubscription;
